import request from "../../utils/request";
import { Result } from "../../models/general";

export interface EmployeeHierarchyView {
    id: string;
    name: string;
    title: string;
    department: string;
    imageUrl?: string;
    email: string;
    phoneNumber?: string;
    directReportIds: string[];
    managerId?: string;
    isManager: boolean;
    employeeCount: number;
}

export async function getHierarchy() {
    const response = await request.get<Result<EmployeeHierarchyView[]>>("OrganizationalStructure/GetHierarchy");
    return response.data;
}

export async function getHierarchyByCompany(companyId: number) {
    const response = await request.get<Result<EmployeeHierarchyView[]>>(`OrganizationalStructure/GetHierarchyByCompany/${companyId}`);
    return response.data;
}
